import type { ReactNode } from "react";
import { Dialog, Text, Button } from "@akina/presentation";

type LegalUpdateModalProps = {
  open: boolean;
  title: string;
  description: ReactNode;
  subtext?: ReactNode;
  buttonLabel: string;
  isPending: boolean;
  onAccept: () => void;
};

export function LegalUpdateModal({
  open,
  title,
  description,
  subtext,
  buttonLabel,
  isPending,
  onAccept,
}: Readonly<LegalUpdateModalProps>) {
  return (
    <Dialog
      withClose={false}
      open={open}
      onEscapeKeyDown={e => e.preventDefault()}
      onInteractOutside={e => e.preventDefault()}
      onOpenAutoFocus={e => e.preventDefault()}
      className="no-scrollbar flex max-w-132 flex-col gap-12">
      <Text size="3xl">{title}</Text>
      <div className="flex flex-col gap-6">
        <Text size="base">{description}</Text>
        {subtext ? <Text size="base">{subtext}</Text> : null}
      </div>
      <Button loading={isPending} className="ml-auto object-contain text-right focus-visible:outline-none" onClick={onAccept}>
        {buttonLabel}
      </Button>
    </Dialog>
  );
}
